import { TrendingUp, Users, Globe, Award, Clock, Shield } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const StatsSection = () => {
  const stats = [
    {
      icon: TrendingUp,
      value: "+45%",
      label: "Rétention des talents",
      description: "Les collaborateurs restent plus longtemps grâce à la flexibilité offerte",
      color: "text-green-600"
    },
    {
      icon: Users,
      value: "89%",
      label: "Satisfaction employés",
      description: "Note moyenne de satisfaction sur l'expérience télétravail international",
      color: "text-blue-600"
    },
    {
      icon: Clock,
      value: "75%",
      label: "Gain de temps RH",
      description: "Réduction du temps consacré à la gestion administrative",
      color: "text-purple-600"
    },
    {
      icon: Globe,
      value: "50+",
      label: "Destinations actives",
      description: "Pays et villes validés et optimisés pour le télétravail",
      color: "text-orange-600"
    },
    {
      icon: Shield,
      value: "100%",
      label: "Conformité garantie",
      description: "Respect des réglementations locales et internationales",
      color: "text-red-600"
    },
    {
      icon: Award,
      value: "2.3x",
      label: "ROI moyen",
      description: "Retour sur investissement mesuré sur la première année",
      color: "text-indigo-600"
    }
  ];

  return (
    <section className="py-24 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Des résultats qui parlent d'eux-mêmes
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Plus de 500 entreprises nous font confiance. Découvrez l'impact mesurable 
            de RENEST sur la performance et le bien-être de vos équipes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <Card key={index} className="group hover:shadow-lg transition-all duration-300 border-0 bg-white">
              <CardContent className="p-8 text-center">
                <div className="space-y-4">
                  <div className={`w-16 h-16 mx-auto rounded-2xl bg-opacity-10 flex items-center justify-center ${
                    stat.color.replace('text-', 'bg-')
                  }`}>
                    <stat.icon className={`h-8 w-8 ${stat.color}`} />
                  </div>
                  
                  <div className="space-y-2">
                    <div className="text-4xl font-bold text-foreground group-hover:scale-105 transition-transform">
                      {stat.value}
                    </div>
                    <div className="text-lg font-semibold text-foreground">
                      {stat.label}
                    </div>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {stat.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom section */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-4 bg-white rounded-2xl p-6 shadow-lg">
            <div className="flex -space-x-3">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="w-12 h-12 rounded-full bg-gradient-to-br from-primary/20 to-primary/40 border-2 border-white flex items-center justify-center text-primary font-bold">
                  {String.fromCharCode(65 + i)}
                </div>
              ))}
            </div>
            <div className="text-left">
              <div className="font-semibold text-foreground">
                Rejoignez plus de 500 entreprises
              </div>
              <div className="text-sm text-muted-foreground">
                qui transforment leur approche du télétravail
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;